<template>
  <div>
    <transition-group>
      <b-list-group
        v-for="(item, index) in items"
        :key="`${item.id}-${index}`"
        :class="itemClass"
        flush
      >
        <b-list-group-item>
          <slot :item="item" :index="index" name="alert" />
          <div
            :class="{
              [defaultClass]: true,
              'cursor-pointer': enableCursorPointer
            }"
            @click.prevent.stop="clickItem(item)"
          >
            <slot :item="item" :index="index" name="list-item" />

            <slot :item="item" :index="index" name="option-front-thumbnail" />

            <slot :item="item" :index="index" name="thumbnail" />

            <div v-if="showDetail" class="pl-0 pl-sm-4 pt-sm-0 pt-3 d-flex flex-column w-100 h-100">
              <slot :item="item" :index="index" name="list-detail" />
            </div>
            <div>
              <slot :item="item" :index="index" name="list-options" />
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>

      <b-list-group
        v-for="(disabledItem, index) in disabledItems"
        :key="`${disabledItem.id}-${index}`"
        :class="itemClass"
        flush
      >
        <b-list-group-item disabled>
          <div
            class="d-flex flex-column flex-sm-row align-items-start mt-2 mb-2"
            :class="{ 'cursor-pointer': enableCursorPointer }"
            @click.prevent.stop="clickItem(disabledItem)"
          >
            <!-- <img
              src="@/assets/default-lu-cover.jpg"
              alt="Rounded image"
              class="img-fluid rounded thumbnail img-size"
            /> -->
            <slot :item="disabledItem" :index="index" name="thumbnail" />
            <div
              class="pl-0 pl-sm-4 pt-sm-0 pt-3 d-flex flex-column justify-content-between w-100 custom-height"
            >
              <slot :item="disabledItem" :index="index" name="disabled-list-detail" />
            </div>
            <div>
              <slot :item="disabledItem" :index="index" name="list-options" />
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
    </transition-group>

    <!-- Loading spinner -->
    <div v-if="fetching" class="d-flex justify-content-center p-4 m-3">
      <b-spinner label="Loading..." variant="dark" />
    </div>
  </div>
</template>

<script>
import { BListGroup, BListGroupItem } from 'bootstrap-vue';

export default {
  name: 'BaseLists',

  components: {
    BListGroup,
    BListGroupItem
  },

  props: {
    items: {
      type: null,
      default: () => []
    },
    disabledItems: {
      type: null,
      default: () => []
    },
    itemClass: {
      type: [String, Array, Object],
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    countLazyLoading: {
      type: Number,
      default: 0
    },
    noMoreItem: {
      type: Boolean,
      default: false
    },
    toggleFetching: {
      type: Boolean,
      default: true
    },
    thumbnail: {
      type: String,
      default: '@/assets/default-lu-cover.jpg'
    },
    enableCursorPointer: {
      type: Boolean,
      default: true
    },
    showDetail: {
      type: Boolean,
      default: true
    },
    defaultClass: {
      type: String,
      default: 'd-flex flex-column flex-sm-row align-items-start mt-2 mb-2'
    }
  },

  data() {
    return {
      fetching: false
    };
  },

  computed: {
    itemLength() {
      return this.items && this.items.length ? this.items.length : 0;
    },
    disabledItemLength() {
      return this.disabledItems && this.disabledItems.length ? this.disabledItems.length : 0;
    }
  },

  watch: {
    toggleFetching: {
      immediate: false,
      handler(toggleFetching) {
        this.fetching = toggleFetching;
      }
    }
  },

  created() {
    this.scroll();
  },

  mounted() {},

  methods: {
    clickItem(item) {
      this.$emit('clickItem', item);
    },
    scroll() {
      if (this.toggleFetching) {
        window.addEventListener('scroll', () => {
          if (this.noMoreItem || this.fetching) return;
          const d = document.documentElement;
          const scrolledY = window.scrollY;
          const height = window.innerHeight;
          if (scrolledY + height >= d.scrollHeight) {
            this.fetching = true;
            let start = 0;
            let limit = 15;
            if (this.countLazyLoading > 0) start = 15 * this.countLazyLoading;
            this.$emit('fetchNewItems', start, limit);
          }
        });
        // window.onscroll = async () => {
        //   if (this.noMoreItem || this.fetching) return;
        //   const d = document.documentElement;
        //   const offset = d.scrollTop + window.innerHeight;
        //   const height = d.offsetHeight;
        //   if (Math.abs(offset - height) < 100) {
        //     this.fetching = true;
        //     let start = 0;
        //     let limit = 15;
        //     if (this.countLazyLoading > 0) start = 15 * this.countLazyLoading;
        //     this.$emit("fetchNewItems", start, limit);
        //   }
        // };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// .custom-height {
//   min-height: 100px !important;
// }

.img-size {
  min-width: 160px;
  max-width: 160px;
  height: 100px;
  max-height: max-content;
}

// @media only screen and (max-width: 576px) {
//   .img-size {
//     width: 320px;
//     height: 200px;
//     max-height: max-content;
//   }
//   .custom-height {
//     height: 120px !important;
//   }
// }
.list-group-item-action:hover,
.list-group-item-action:active,
.list-group-item-action:focus {
  background-color: rgb(255, 255, 255);
}
.cursor-pointer {
  cursor: pointer;
}
</style>
